// @ts-expect-error - bender-url is not typed
import defaultCompanyImage from 'bender-url!avatar-components/images/default-company-avatar.png';
// @ts-expect-error - bender-url is not typed
import defaultContactImage from 'bender-url!avatar-components/images/default-avatar.png';
import { AVATAR_TYPES } from '../Constants';
import { getBorderProps, getMarginProps } from './stylePropHelpers';
export const getIsLatinCharacters = str => {
  const nonLatin = /[^\u0020-\u01BF]/;
  return nonLatin.test(str);
};
export const maybeGetANameOutOfEmailAddress = str => {
  if (!str || !str.indexOf('@')) {
    return str;
  }
  return str.split('_').join(' ');
};
export const displayNameToInitials = ({
  aString,
  displayName,
  passed
}) => {
  if (passed || !aString || typeof aString !== 'string') {
    return undefined;
  }
  if (!aString || getIsLatinCharacters(aString) && !passed) {
    return displayNameToInitials({
      aString: maybeGetANameOutOfEmailAddress(displayName),
      passed: true
    });
  }
  const names = aString.split(' ');
  let initials = names[0].substring(0, 1);
  if (names.length > 1) {
    initials += names[names.length - 1].substring(0, 1);
  }
  return initials;
};
export const getDefaultAvatar = type => {
  if (type && type in AVATAR_TYPES) {
    const mappedType = AVATAR_TYPES[type];
    if (mappedType === AVATAR_TYPES.company) {
      return defaultCompanyImage;
    } else if (mappedType === AVATAR_TYPES.contact) {
      return defaultContactImage;
    }
  }
  return undefined;
};
export const pickToolTipName = lookupObj => {
  const {
    displayName,
    domain,
    email,
    primaryIdentifier,
    secondaryIdentifier,
    src
  } = lookupObj;
  const display = displayName || email || domain || typeof primaryIdentifier !== 'number' && primaryIdentifier || secondaryIdentifier || src || undefined;
  return `${display}`;
};
export const getAvatarContainerProps = (props, state) => {
  const marginProps = getMarginProps(props);
  const borderProps = getBorderProps(props);
  return Object.assign({
    isEditable: props.isEditable,
    isTooltipLoaded: state.isTooltipLoaded,
    onClick: props.onClick,
    showTooltip: props.showTooltip,
    size: props.size,
    tooltipPlacement: props.tooltipPlacement,
    tooltipTitle: props.tooltipTitle || props.displayName,
    type: props.type
  }, marginProps, borderProps);
};
export const getAvatarContentWrapperProps = props => ({
  backgroundColor: props.backgroundColor,
  href: props.href,
  iconColor: props.iconColor,
  iconType: props.iconType,
  isEditable: props.isEditable,
  size: props.size,
  socialNetwork: props.socialNetwork,
  src: props.src,
  type: props.type
});
export const getAvatarContentProps = props => {
  return {
    displayName: props.displayName,
    iconType: props.iconType,
    size: props.size,
    src: props.src
  };
};